import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["nb", "en", "sv", "da", "no"],
    fallbackLng: "nb",
    detection: {
      order: ["localStorage", "cookie", "queryString", "navigator"],
      caches: ["localStorage", "cookie"],
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "i18next",
    },
    backend: {
      // Manual cache-buster — bump on every translation.json change, or
      // browsers keep serving the cached copy and new keys render raw.
      loadPath: "/locales/{{lng}}/translation.json?v=4.3.8",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    // Map legacy "no" code to "nb"
    load: "currentOnly",
    nonExplicitSupportedLngs: false,
  });

// Redirect legacy "no" to "nb"
if (i18n.language === "no") {
  i18n.changeLanguage("nb");
}

export default i18n;
